<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard" error-color="#EB5E28" color="#1e94fd" title="Pasivos" subtitle="" @on-complete="siguente" @on-change="cancelAll">
            <tab-content title="Adeudos / Pasivos (Situación actual)" icon="ti-user">
              <deudas ref="Deudas"></deudas>
            </tab-content>
            <!--
            <tab-content title="Otras obligaciones" icon="ti-user">
              <otras-obligaciones ref="OtrasObligaciones"></otras-obligaciones>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Atrás</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button>
            -->
            <tab-content title="Préstamo o Comodato por terceros (Situación actual)" icon="ti-user">
              <prestamo ref="Prestamo"></prestamo>
            </tab-content>
            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"> Atrás </button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next"> Siguiente </button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd btn-next"> Siguiente</button><!-- @click="siguente()" -->
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Deudas from './Formularios/Pasivos/Deudas.vue'
  /*  import OtrasObligaciones from './Formularios/Pasivos/OtrasObligaciones.vue'
   import Fideicomisos from './Formularios/Pasivos/Fideicomisos.vue'
   import BienesIntangibles from './Formularios/Pasivos/Fideicomisos.vue'
   import UsoEspeciePropiedadTercero from './Formularios/Pasivos/Fideicomisos.vue'
   import PasivosForm from './Formularios/Pasivos/PasivosForm.vue'
   import OtrasObligacioness from './Formularios/Pasivos/OtrasObligacioness.vue' */
  import Prestamo from "./Formularios/Pasivos/PrestamoComodato.vue";
  import swal from 'sweetalert2'
  export default {
    data() {
      return {
        wizardModel: {}
      }
    },
    components: {
      FormWizard,
      TabContent,
      Deudas,
      Prestamo,
      /*  OtrasObligaciones,
       Fideicomisos,
       BienesIntangibles,
       UsoEspeciePropiedadTercero,
       PasivosForm,
       OtrasObligacioness */
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      cancelAll() {
        var tab = this.$refs.wizard.tabs[this.$refs.wizard.activeTabIndex].$children;
        tab[0].cancelEdit();
      },
      checkPermissions() {
        // && this.getKey('grupo') != 3
        if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      /* validateFirstStep() {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep() {
        return this.$refs.secondStep.validate()
      }, */
      siguente() {
        this.$router.push('fiscal');
      },
      /*  wizardComplete() {
         // we gather models from all steps into one model
         this.wizardModel = {
           ...this.$refs.datosPersonales.model,
           ...this.$refs.firstStep.model,
           ...this.$refs.DatosCurriculares.model,
           ...this.$refs.DatosConyuge.model,
           ...this.$refs.secondStep.model
         }
         swal('Good job!', 'You clicked the finish button!', 'success')
       } */
    },
    created() {
      this.checkPermissions();
    },
    mounted() {
      this.$refs.wizard.activateAll();
    }
  }

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Pasivos.vue